module.exports = __webpack_public_path__ + "img/order.c78a424a.png";